var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseLayout',{attrs:{"wrapperClass":"home"}},[_c('HeroBanner'),_c('ImageGallery'),_c('SubscribeSeparator'),(_vm.hrEnabled)?_c('MostPurchased'):_vm._e(),(_vm.hrEnabled)?_c('Retargeted'):_vm._e(),_c('OurStores'),_c('OurBrands')],1)}
var staticRenderFns = []

export { render, staticRenderFns }